import useAjax from '@/functions/use_ajax';
import { generateFile } from './generate_file';

export function annotateImage(event, currentImage, originalImage) {
  let annotatedImage = {
    isNew: true,
    id: currentImage?.id,
    description: currentImage?.description,
    image_blob: {
      filename: currentImage?.image_blob['filename'],
      content_type: currentImage?.image_blob['content_type']
    },
    original_image_blob: {...currentImage?.original_image_blob},
    created_at: new Date(),
    attached: true,
    original_upload: currentImage?.original_upload,
    issue_id: currentImage?.issue_id,
    markup: event.state,
  };

  // Set the original image to the previous primary image if the original was empty
  if (!annotatedImage.original_image_blob || Object.keys(annotatedImage.original_image_blob).length === 0) {
    annotatedImage.original_image_blob = {...currentImage?.image_blob};
    annotatedImage.original_upload = currentImage?.upload;
  }

  annotatedImage.original_url = originalImage.src;
  annotatedImage.url = event.dataUrl;

  return annotatedImage;
}

export async function saveAnnotatedImage(annotatedImage, uploader, issuePath, isShaft) {
  let file = await generateFile(annotatedImage);

  annotatedImage.upload = uploader.create(file);

  if (annotatedImage?.issue_id) {
    await uploadImage(annotatedImage, uploader, issuePath, isShaft);
  }
}

async function uploadImage(currentImage, uploader, issuePath, isShaft) {
  const ajax = useAjax();
  const blob = await uploader.upload(currentImage.upload);

  let { ok, data } = await ajax(issuePath, {
    method: 'PATCH',
    body: updateBody(currentImage, blob, isShaft),
  });

  if (ok) {
    let issueImages;

    if (data?.issue_images) {
      issueImages = data?.issue_images;
    } else if (data?.detail?.issue_images) {
      issueImages = data?.detail?.issue_images;
    }

    let index = issueImages.findIndex((image) => {
      return image['id'] === currentImage['id'];
    });
    Object.assign(currentImage.image_blob, issueImages[index].image_blob);
  }
}

function updateBody(image, imageBlob, isShaft) {
  if (isShaft) {
    return {
      activity: {
        detail_attributes: {
          ...issueImagesAttributes(image, imageBlob),
        },
      },
    };
  } else {
    return {
      issue: {
        id: image.issue_id,
        ...issueImagesAttributes(image, imageBlob),
      },
    };
  }
}

function issueImagesAttributes(image, imageBlob) {
  return {
    issue_images_attributes: [
      {
        id: image.id,
        image: imageBlob.signed_id,
        original_image: image.original_image_blob?.signed_id,
        markup: image.markup,
      },
    ],
  };
}
